import ErrorPage from "@/pages/_error";
import { defineMessage, useIntl } from "react-intl";
import ProjectFileBrowser from "@/components/ProjectFileBrowser";
import { intoPath } from "@/utils/url";
import { useLocation } from "react-router";
import Outlet from "@/common/Outlet";
import { getCompetitionCodePath, parseFileKind } from "@/utils/routing";
import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { CompetitionCodePageQuery as CompetitionCodePageQueryType } from "./__generated__/CompetitionCodePageQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
export default function CompetitionCodePage() {
  const location = useLocation();
  const intl = useIntl();
  const {
    query: { competitionBySlug: competition },
  } = useCompetitionCodePageQuery();
  if (!competition) {
    return (
      <ErrorPage
        status={404}
        message={intl.formatMessage({ defaultMessage: "Data set not found" })}
      />
    );
  }
  const rootPath = intoPath(
    getCompetitionCodePath(
      competition.event.event.slug,
      competition.slug,
      undefined,
    ),
    location.search,
  );
  return (
    <div className="pb-16">
      <ProjectFileBrowser
        root={rootPath}
        project={competition.useCase}
        competition={competition.slug}
      >
        <Outlet />
      </ProjectFileBrowser>
    </div>
  );
}
const CompetitionCodePageQuery = graphql`
  query CompetitionCodePageQuery(
    $owner: String!
    $slug: String!
    $fileKind: ProjectVersionFileKind!
  ) {
    competitionBySlug(slug: $slug) {
      slug
      event(slug: $owner) {
        event {
          slug
        }
      }
      title
      useCase {
        ...ProjectFileBrowserFragment @arguments(kind: $fileKind)
      }
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { slug: owner, track: slug, kind } }: LoaderArgs) => {
    if (!slug || !owner) {
      throw new Response("No slug or owner", { status: 500 });
    }
    return preload<CompetitionCodePageQueryType>(
      environment,
      CompetitionCodePageQuery,
      {
        owner,
        slug,
        fileKind: parseFileKind(kind),
      },
    );
  };
};
const useCompetitionCodePageQuery = () =>
  usePreloaded<CompetitionCodePageQueryType>();
export const lazyHandle = {
  titleI18n: defineMessage({ defaultMessage: "Code" }),
};
